<template>
  <v-container class="px-md-12">
    <h2 class="mb-4 px-4 px-md-0">Integraciones</h2>
    <v-row class="mx-0 my-3">
      <v-col cols="12" md="3" v-for="(collaboration, index) in collaborations" :key="index">
        <v-card class="pa-6">
          <v-row class="ma-0">
            <div>
            <v-icon>{{collaboration.icon}}</v-icon>
            <v-card-title class="px-0">{{collaboration.name}}</v-card-title>
            </div>
            <v-spacer/>
            <v-btn  disabled size="x-small" variant="outlined">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-row>
          <v-card-subtitle class="pa-0">{{collaboration.description}}</v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script setup lang="ts">
import { defineComponent } from 'vue'

type Integration = {
  name: string
  icon: string
  description: string
}


const collaborations: Integration[] = [
  {
    name: 'WhatsApp Business API',
    icon: 'mdi-whatsapp',
    description: 'Conecta tu WhatsApp empresarial.',
  },
  {
    name: 'Instagram API',
    icon: 'mdi-instagram',
    description: 'Gestiona mensajes de Instagram.',
  },
  {
    name: 'Facebook API',
    icon: 'mdi-facebook',
    description: 'Administra Facebook Messenger.',
  },
  {
    name: 'Gmail',
    icon: 'mdi-gmail',
    description: 'Envía y recibe correos de Gmail.',
  },
  {
    name: 'Google Meet',
    icon: 'mdi-video',
    description: 'Agrega videollamadas Meet.',
  },
  {
    name: 'ChatGPT',
    icon: 'mdi-robot-outline',
    description: 'Automatiza respuestas con IA.',
  },
]

</script>
